import { Fragment } from 'react';
import { StyledHeaderMenuItemGroup, StyledMenu } from './styles';
import { Label } from '@mindtickle/label';
import { TEXT_MODIFIERS, TEXT_TYPES, TEXT_COLORS } from '@mindtickle/styles/lib/classNames';
import { ReactNode } from 'react';

export interface HelpMenuOptionItem {
  content: ReactNode;
  key: string;
  callFn: () => void;
  disabled?: boolean;
  hide?: boolean;
  dataTestId?: string;
  displayOrder: number;
}

interface HelpMenuOptionProps {
  helpMenuOptions: Record<string, HelpMenuOptionItem>;
}

const HelpMenuOption = ({ helpMenuOptions }: HelpMenuOptionProps) => {
  const options = Object.values(helpMenuOptions).sort((a, b) => a.displayOrder - b.displayOrder);

  return (
    <StyledMenu>
      {options.map(
        ({ content, key, callFn, disabled = false, hide, dataTestId }) =>
          !hide && (
            <Fragment key={key}>
              {!disabled ? (
                <StyledHeaderMenuItemGroup>
                  <Label
                    tag="div"
                    onClick={callFn}
                    data-testid={dataTestId}
                    className="help-menu-item"
                    color={TEXT_COLORS.TERTIARY}
                    type={TEXT_TYPES.BODY_MEDIUM_DEFAULT}
                    modifier={TEXT_MODIFIERS.TYPOGRAPHY_MOD_STRONG}
                  >
                    {content}
                  </Label>
                </StyledHeaderMenuItemGroup>
              ) : (
                content
              )}
            </Fragment>
          )
      )}
    </StyledMenu>
  );
};

export default HelpMenuOption;
